import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteConfigContext = createContext({
  site_theme: "verde",
  custom_theme: null,
  hero_images: [],
  hero_interval: 7,
  hero_transition: "crossfade",
  hero_overlay_active: true,
  hero_overlay_intensity: "media",
  brand_logos: [],
  contact_email: "ventas@west-kac.com",
  whatsapp_phone: "",
  privacy_html: "",
  terms_html: "",
});

export function SiteConfigProvider({ children }) {
  const [cfg, setCfg] = useState({
    site_theme: localStorage.getItem("wk_site_theme") || "verde",
    custom_theme: null,
    hero_images: [],
    hero_interval: 7,
    hero_transition: "crossfade",
    hero_overlay_active: true,
    hero_overlay_intensity: "media",
    brand_logos: [],
    contact_email: "ventas@west-kac.com",
    whatsapp_phone: "",
    privacy_html: "",
    terms_html: "",
  });
  useEffect(() => {
    api.get("/public/site-config")
      .then((r) => {
        const d = r.data || {};
        setCfg({
          site_theme: d.site_theme || "verde",
          custom_theme: d.custom_theme || null,
          hero_images: d.hero_images || [],
          hero_interval: d.hero_interval || 7,
          hero_transition: d.hero_transition || "crossfade",
          hero_overlay_active: d.hero_overlay_active !== false,
          hero_overlay_intensity: d.hero_overlay_intensity || "media",
          brand_logos: d.brand_logos || [],
          contact_email: d.contact_email || "ventas@west-kac.com",
          whatsapp_phone: d.whatsapp_phone || "",
          privacy_html: d.privacy_html || "",
          terms_html: d.terms_html || "",
        });
        localStorage.setItem("wk_site_theme", d.site_theme || "verde");
      })
      .catch(() => {});
  }, []);
  return <SiteConfigContext.Provider value={cfg}>{children}</SiteConfigContext.Provider>;
}

export const useSiteConfig = () => useContext(SiteConfigContext);
